import { Bar, BarChart as BarChartRechars, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { isEmpty } from "remeda";

import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

type BarChartComponentProps = {
  data: unknown[];
  dataKey: string;
  barDataKey: string;
  barName: string;
  color: string;
  title: string;
  className?: string;
  hideX?: boolean;
};

export default function BarChart({
  data = [],
  dataKey,
  barDataKey,
  barName,
  color,
  className,
  title,
  hideX = false,
}: BarChartComponentProps) {
  const hasLongNames = data.some((bar: any) => {
    return bar[dataKey]?.length > 5;
  });
  return (
    <div className={cn("w-full rounded-md bg-white p-4 text-black shadow-md md:w-[45%]", className)}>
      <Typography className="mb-4 text-black" variant="text-lg" weight="semibold">
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        {isEmpty(data) ? (
          <Typography className="text-center" weight="bold" variant="display-sm">
            No data
          </Typography>
        ) : (
          <BarChartRechars data={data}>
            <XAxis hide={data.length > 10 || hideX || hasLongNames} interval={0} dataKey={dataKey} />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey={barDataKey} name={barName} fill={color} />
          </BarChartRechars>
        )}
      </ResponsiveContainer>
    </div>
  );
}
